<template>
    <b-navbar id="cookiebar" :fixed-bottom="true" :mobile-burger="false">
        <template slot="start">
            <div id="consent-banner" style="padding: 0"></div>
        </template>
    </b-navbar>
</template>

<style>
    #cookiebar .navbar-brand, #cookiebar .navbar-end {
        display: none;
        max-height: 0;
        max-width: 0;
    }
    #cookiebar .navbar-menu {
        width: 1000px;
        display: flex;
    }
    .gray-background {
        background-color: #f7f7f7;
    }
</style>

<script>
    const sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    };
    function addClass(elementName, className) {
        const element = document.getElementById(elementName);
        if (element) element.classList.add(className);
    }
    function removeClass(elementName, className) {
        const element = document.getElementById(elementName);
        if (element) element.classList.remove(className);
    }
    var cookieManagerSetUp = false;
    function setupCookieManager() {
        if (!cookieManagerSetUp) {
            const closeX = document.getElementById('truste-consent-close');
            if (closeX) {
                closeX.addEventListener("click", hideCookieBar);

                const closeButton = document.getElementById('truste-consent-button');
                if (closeButton) closeButton.addEventListener("click", hideCookieBar);

                addClass('cookiebar', 'gray-background');
                addClass('truste-consent-content', 'gray-background');
                addClass('body', 'has-navbar-fixed-bottom');

                const cookiebar = document.getElementById('cookiebar');
                if (cookiebar) {
                    cookiebar.style.display = 'flex';
                }
                cookieManagerSetUp = true;
            }
        }
    }
    function hideCookieBar() {
        const cookiebar = document.getElementById("cookiebar");
        if (cookiebar) cookiebar.remove();
        removeClass('body', 'has-navbar-fixed-bottom');
    }
    export default {
        mounted: function() {
            const consentBanner = document.getElementById("consent-banner");
            const scriptTag = document.createElement("script");
            scriptTag.setAttribute("type", "text/javascript");
            scriptTag.setAttribute("async", "async");
            scriptTag.setAttribute("src", "https://consent.trustarc.com/v2/notice/l5vs6f");
            if (consentBanner) consentBanner.appendChild(scriptTag);
            //Hide the bottom cookie bar until the cookie manager has been loaded from the script
            removeClass('body', 'has-navbar-fixed-bottom');
            const cookiebar = document.getElementById("cookiebar");
            cookiebar.style.padding = '0';
            cookiebar.style.display = 'none';
            //Give it 10 seconds to load checking every half second, then set up button listeners and override css
            for (var i = 500; i < 10000; i = i + 500) {
                sleep(i).then(() => setupCookieManager());
            }
        }
    }
</script>
